import styled from "styled-components";

export const SectionContainer = styled.div`
  max-width: 1440px;
  padding: 0 20px;
  width: 100%;
  height: 100%;
  position: relative;
  margin: 0 auto;
  &.theme-2 {
    max-width: 1240px;
  }
`;

export const ProductIntroContainer = styled.div`
  .label {
    text-align: center;
    margin: 100px 0 50px;
    span {
      display: block;
      &:first-child {
        font-size: 48px;
        font-weight: 800;
        margin-bottom: 15px;
      }
    }
  }
  .section {
    max-width: 1440px;
    padding: 0 20px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    gap: 50px;
  }
  .info {
    .category {
      display: flex;
      gap: 10px 30px;
      flex-wrap: wrap;
      margin-bottom: 30px;
      li {
        color: #8a8a8a;
        cursor: pointer;
        transition: 0.3s;
        &.active {
          color: #000;
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    span {
      width: fit-content;
      height: fit-content;
      padding: 5px 20px;
      background: #3b8ef6;
      color: #fff;
      font-weight: 700;
      display: flex;
      border-radius: 40px;
      align-items: center;
      justify-content: center;
      box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
    }
    strong {
      display: block;
      margin: 30px 0;
      font-size: 58px;
      font-weight: 700;
      width: 350px;
    }
    p {
      color: #666;
      font-size: 20px;
      white-space: pre-line;
    }
  }
  .products {
    width: calc(100% - 450px);
    &.half .mySwiper {
      height: 250px;
    }
    .mySwiper {
      width: 100%;
      height: 500px;
      background: rgba(196, 205, 223, 0.5);
    }
    .progress-indicator {
      /* position: absolute;
      top: 10px;
      left: 10px; */
      padding: 5px 10px;
      background-color: rgba(0, 0, 0, 0.7);
      color: white;
      font-size: 14px;
      border-radius: 4px;
      z-index: 10;
    }
    .content {
      display: flex;
      flex-wrap: wrap;
      height: 100%;
      .box {
        width: calc(100% / 3);
        height: 50%;
        padding: 25px;
        text-align: center;
        position: relative;
        background: #f5f5f6;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover {
          .intro {
            opacity: 1;
          }
        }
      }
      img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
      }
      .intro {
        transition: 0.3s;
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.5);
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        gap: 20px;
        padding: 20px;
        opacity: 0;
        span {
          text-align: left;
          display: block;
          color: #fff;
          font-weight: 24;
          font-weight: 700;
        }
        button {
          width: 170px;
          display: flex;
          justify-content: space-between;
          height: 40px;
          background: transparent;
          border-bottom: 1px solid #fff;
          color: #fff;
          svg {
            display: block;
            margin: 0;
          }
        }
      }
    }
    .progress {
      margin-top: 30px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      gap: 10px;
      span {
        font-size: smaller;
        color: #787878;
      }
      .bar {
        width: 400px;
        height: 1px;
        background: #b6b6b6;
        p {
          background: #000;
          height: 1px;
        }
      }
    }
  }
  @media screen and (max-width: 1400px) {
    .section {
      flex-wrap: wrap;
      .info,
      .products {
        width: 100%;
      }
      .info strong {
        width: 100%;
        font-size: 48px;
      }
      .products .content .box {
        padding: 20px;
      }
    }
  }
  @media screen and (max-width: 1050px) {
    .section {
      gap: 30px;
    }
  }
  @media screen and (max-width: 767px) {
    .section {
      gap: 20px;
      .info {
        .category {
          gap: 10px;
          font-size: 14px;
        }
        strong {
          margin: 10px 0;
        }
        strong {
          font-size: 20px;
        }
        p {
          font-size: medium;
        }
      }
      .products {
        height: calc(100vw - 40px);
        max-height: 400px;
        .mySwiper {
          height: 100%;
        }
        .content .box {
          padding: 10px;
          width: 50%;
        }
        .content .intro {
          opacity: 1;
          background: rgba(0, 0, 0, 0.2);
          span {
            max-width: 100%;
            font-size: 16px;
          }
          button {
            display: none;
          }
        }
        .progress span {
          font-size: medium;
        }
      }
    }
    .label {
      span:first-child {
        font-size: 36px;
      }
    }
  }
`;

export const ListContainer = styled.ul`
  gap: 70px 20px;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  li {
    width: calc((100% - 60px) / 4);
    cursor: pointer;
    .image {
      width: 100%;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        transition: 0.3s;
      }
    }
    .info {
      span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
        transition: 0.3s;
      }
    }
  }
  &.theme-0 {
    margin-top: 50px;
    li {
      .image {
        aspect-ratio: 1;
        border: 1px solid #ddd;
        img {
          object-fit: contain;
        }
      }
      span.name {
        font-size: larger;
        margin: 10px 0;
        font-weight: 700;
      }
      &:hover {
        img {
          transform: scale(1.2);
        }
        span {
          color: #e9463f;
        }
      }
    }
  }
  &.theme-2 {
    li {
      text-align: left;
      .image {
        aspect-ratio: 1 / 1.3;
        margin-bottom: 20px;
        border-radius: 10px;
        img {
          object-fit: cover;
        }
      }
      span {
        &.name {
          margin-bottom: 10px;
          font-weight: 300;
          color: #3a3a3a;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
        &.date {
          display: none;
        }
      }
    }
  }
  &.theme-4 {
    gap: 20px;
    li {
      width: calc((100% - 60px) / 4);
      border: 1px solid #b9b9b9;
      .image {
        aspect-ratio: 1 / 1.3;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .info {
        padding: 20px;
        border-top: 1px solid #b9b9b9;
        span:first-child {
          margin-bottom: 10px;
        }
        span:last-child {
          color: #afafaf;
          font-size: smaller;
        }
      }
      &:hover {
        .image img {
          transform: scale(1.2);
        }
      }
    }
  }
  @media screen and (max-width: 1050px) {
    gap: 50px 20px;
    li {
      width: calc((100% - 60px) / 4);
    }
  }

  @media screen and (max-width: 767px) {
    gap: 20px;
    margin-top: 30px;
    &.theme-4 li {
      width: calc(50% - 10px);
      .info {
        padding: 10px;
      }
    }
    li {
      width: calc(50% - 10px);
    }
  }
`;
